/**
 * Structural snapshot contract for the render layer.
 * Compatible with @afr/sim SimSnapshot — render never runs sim logic.
 */
/** Default bridge half-width — matches sim PATH_HALF_WIDTH baseline. */
export const DEFAULT_PATH_HALF_WIDTH = 3.5;
/** Soft visual cap: prefer full meshes up to this count. */
export const RENDER_SOFT_INSTANCE_CAP = 100;
/** Hard draw cap for InstancedMesh (logical N may exceed). */
export const RENDER_HARD_INSTANCE_CAP = 250;
/**
 * Soft cap for drawn zombie bodies (horde density readability).
 * Combined with squad hard cap stays inside the 400–800 mid-phone budget.
 */
export const RENDER_SOFT_HORDE_CAP = 120;
/** Hard draw cap for horde InstancedMesh pool (never uncapped). */
export const RENDER_HARD_HORDE_CAP = 280;
/**
 * Combined scene draw budget (squad + horde). LOD clamps each pool so
 * mid-phone stays in the ~400–800 full-unit band from the ad contract.
 */
export const RENDER_COMBINED_UNIT_BUDGET = 520;
/**
 * Map logical unit count → drawn instance count (LOD).
 * Soft cap keeps every unit; above soft, step down toward hard cap.
 */
export function instanceCountForN(n, softCap = RENDER_SOFT_INSTANCE_CAP, hardCap = RENDER_HARD_INSTANCE_CAP) {
    const count = Math.max(0, Math.floor(n));
    if (count <= softCap)
        return count;
    if (count <= hardCap)
        return count;
    return hardCap;
}
/** World-space centroid from a sim snapshot (Y always 0 for path plane). */
export function centroidFromSnapshot(snap) {
    return { x: snap.lateralX, y: 0, z: snap.pathZ };
}
/**
 * Select up to `drawn` formation slots for instancing.
 * Prefer lowest indices (near centroid); outer ring is culled first under LOD.
 */
export function slotsForInstances(formation, drawn) {
    if (drawn <= 0)
        return [];
    if (formation.length <= drawn)
        return formation;
    return formation.slice(0, drawn);
}
//# sourceMappingURL=snapshot.js.map